module.exports = __webpack_public_path__ + "img/katarina_bedrooms_16.f35871cb.jpg";